import { env } from "@watt/common/config/env";

export function isProductionEnvironment(): boolean {
  return env.NEXT_PUBLIC_ENVIRONMENT === "production";
}

export function isDevEnvironment(): boolean {
  return env.NEXT_PUBLIC_ENVIRONMENT === "develop";
}

export function isLocalEnvironment(): boolean {
  return process.env.NODE_ENV === "development";
}

/** Dev/local quick-login UI and server actions — never enabled in production or other deployed envs. */
export function isQuickLoginEnabled(): boolean {
  if (isProductionEnvironment()) {
    return false;
  }
  return isDevEnvironment() || isLocalEnvironment();
}

export function isCloudDatabase(): boolean {
  return !env.DATABASE_URL?.includes("@localhost");
}

export function isPrismaAccelerateEnabled(): boolean {
  return env.DATABASE_URL?.includes("accelerate.prisma-data.net");
}

export function isVercelEnvironment(): boolean {
  return process.env.VERCEL_ENV !== undefined;
}
